import isEmpty from 'lodash.isempty';
import { createStatMarkupForArrays, joinWithCommas, hasDatePassed } from './utils';

export default function programPdp(hit, overline, simple = false) {
  const { title, modes, subject_areas, url, intro_headline, program_dates } = hit;

  // formats a plaintext date string to a url query string
  const getDateStamp = date => {
    const d = new Date(date);
    const day = `0${d.getDate()}`.slice(-2);
    const month = `0${d.getMonth() + 1}`.slice(-2);
    const year = d.getFullYear();
    return `${month}${day}${year}`;
  };

  const renderedFormatAndSubjectArea = `
    ${createStatMarkupForArrays('Format', modes)}
    ${createStatMarkupForArrays('Subject Area', subject_areas)}
  `;

  const programDates = !isEmpty(program_dates)
    ? Object.entries(program_dates).reduce(
      (acc, [date, { cost, format, registration_deadline, length }]) => {
        //PDP registration ends midnight of the next day, not on the day of reg deadline
        const reg_deadline_next_day = new Date(registration_deadline);
        reg_deadline_next_day.setDate(reg_deadline_next_day.getDate() + 1);
        const hasPassed = hasDatePassed(reg_deadline_next_day);

        if (hasPassed) {
          return acc;
        }

        const template = `
            <div class="tease__date-group">
              <p class="tease__date--pdp"><a href="${url}?date=${getDateStamp(
  date,
)}">${date}</a></p>
              <div class="stat-group">
                <h4 class="stat-group__label">Length</h4>
                <p class="stat-group__desc">${length}</p>
              </div>
              <div class="stat-group">
                <h4 class="stat-group__label">Registration Deadline</h4>
                <p class="stat-group__desc">${registration_deadline}</p>
              </div>
              <div class="stat-group">
                <h4 class="stat-group__label">Cost</h4>
                <p class="stat-group__desc">${cost}</p>
              </div>
              <div class="stat-group">
                <h4 class="stat-group__label">Format</h4>
                <p class="stat-group__desc">${format}</p>
              </div>
            </div>
          `;
        return acc + template;
      },
      '',
    )
    : '';

  return `
  <div class="tease tease--search tease--pdp-program">
    ${overline ? `<span class="tease__overline">${joinWithCommas(hit[overline])}</span>` : ''}
    <div class="tease__inner">
      <div class="tease__text-mod">
        <a class="tease__hgroup" href="${url}"}>
          <h2 class="tease__h">
            <span class="tease__h-underline">${title}</span>
          </h2>
          ${intro_headline ? `<p class="tease__desc">${intro_headline}</p>` : ''}
        </a>
      </div>
      <div class="${simple ? 'tease__stats tease__stat-mod--simple' : 'tease__stats'}">
        ${simple ? '' : '<h3 class="tease__date-label">Start Dates</h3>'}
        ${simple ? renderedFormatAndSubjectArea : programDates}
      </div>
    </div>
  </div>`;
}
